import { FeeType, FeeAccounting } from 'further-types/investment';

type FeeWithExported = {
  feeType?: FeeType | null;
  feeAccounting?: FeeAccounting | null;
  isExportedToCustodian?: boolean;
  custodian?: boolean;
  viaExit?: boolean;
  viaExitId?: unknown;
};

export const dateChangeWillAffectFees = (
  fees: Array<FeeWithExported> | undefined,
): boolean => {
  if (!fees?.length) {
    return false;
  }

  return (
    fees.some(
      (fee) =>
        fee.feeType === FeeType.Initial || fee.feeType === FeeType.Recurring,
    ) &&
    fees.every(
      (fee) =>
        !(fee.isExportedToCustodian ?? fee.custodian) &&
        !(fee.viaExit ?? fee.viaExitId),
    )
  );
};
